import { render, staticRenderFns } from "./Jurisdiction.vue?vue&type=template&id=e4e545b2&scoped=true"
import script from "./Jurisdiction.vue?vue&type=script&lang=js"
export * from "./Jurisdiction.vue?vue&type=script&lang=js"
import style0 from "./Jurisdiction.vue?vue&type=style&index=0&id=e4e545b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e545b2",
  null
  
)

export default component.exports